import { Box, IconButton } from "@chakra-ui/react";
import React, { useEffect, useMemo, useState } from "react";
import { RiDeleteBinLine, RiFileEditLine } from "react-icons/ri";
import { useDispatch, useSelector } from "react-redux";
import CTable from "../../../components/Table/table";
import { openAddSectionkModel } from "../../../modules/admin-modules/models/Actions";
import { deleteAdminSectionRequest } from "../../../modules/admin-modules/sections/Actions";
import { brandPalette } from "../../../constants/brandPalette";

const C = {
  primary: brandPalette.primary,
  secondary: brandPalette.accentDark,
  border: brandPalette.stone,
};

const iconBtnProps = {
  variant: "ghost",
  border: "0",
  size: "sm",
  color: C.primary,
  _hover: { bg: "rgba(91, 13, 22, 0.08)", color: C.secondary },
};

const SectionsTable = ({ setAdd, setSelectedData, searchTerm = "" }) => {
  const sections = useSelector((state) => state.adminSections.sections);
  const dispatch = useDispatch();
  const isLoading = useSelector((state) => state.adminSections.isLoading);
  const [offset, setPage] = useState(0);
  const [size, setPerPage] = useState(10);
  const [pageNumber, setPageNumber] = useState(0);

  const list = useMemo(() => {
    const raw = Array.isArray(sections) ? sections : [];
    const q = (searchTerm || "").trim().toLowerCase();
    if (!q) return raw;
    return raw.filter((s) => s?.name?.toLowerCase().includes(q));
  }, [sections, searchTerm]);

  useEffect(() => {
    setPageNumber(0);
  }, [searchTerm]);

  const viewData = (row) => {
    const plain = list.find((s) => s.id === row?.id) ?? row;
    setSelectedData(plain);
  };

  const Data = list.map((data) => ({
    ...data,
    id: data?.id,
    name: data?.name,
    edit: (
      <IconButton
        {...iconBtnProps}
        aria-label="Edit section"
        fontSize="20px"
        icon={<RiFileEditLine />}
        onClick={(e) => {
          e.stopPropagation();
          setSelectedData(data);
          setAdd(false);
          dispatch(openAddSectionkModel());
        }}
      />
    ),
    delete: (
      <IconButton
        {...iconBtnProps}
        aria-label="Delete section"
        fontSize="20px"
        icon={<RiDeleteBinLine color="#9b2c2c" />}
        onClick={(e) => {
          e.stopPropagation();
          dispatch(deleteAdminSectionRequest(data?.id));
        }}
      />
    ),
  }));

  const columns = [
    { Header: "Course name", accessor: "name" },
    { Header: "Edit", accessor: "edit" },
    { Header: "Delete", accessor: "delete" },
  ];

  const totalPage = Math.max(1, Math.ceil(list.length / size));

  return (
    <Box px={{ base: 4, md: 8 }} pb={10} w="100%">
      <Box
        bg="rgba(255,255,255,0.9)"
        border="1px solid"
        borderColor={C.border}
        borderRadius="16px"
        overflow="hidden"
        boxShadow="sm"
      >
        <CTable
          selectedData={viewData}
          Columns={columns}
          Data={Data}
          path="openModel"
          Title=""
          subTitle=""
          btnTitle=""
          placeHolder=""
          noSearchBar
          noFilter
          footerBtnTitle
          filterList
          addButton
          addButtonTitle=""
          setPage={setPage}
          setPerPage={setPerPage}
          currentpage={pageNumber}
          setPageNumber={setPageNumber}
          noSecondSearchBar
          isLoading={isLoading}
          perPage={size}
          totalPage={totalPage}
          wrapperProps={{ maxH: "unset", overflow: "auto" }}
          tableProps={{ bg: "transparent", borderRadius: "0", mb: 0 }}
          theadProps={{ bg: brandPalette.stone, color: brandPalette.accentDark }}
        />
      </Box>
    </Box>
  );
};

export default SectionsTable;
